import React, { useState, useEffect } from "react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTable from "../useTable";
import ModalConfigUserWeb from "./modalConfUserWeb";
import axios from "axios";
import { Dimmer } from "../spinner";
import { Mensaje } from "../mensajes";
import { ToastsGeneral } from "../toasts";
import { SelectTipoUsu } from "./modalSelectTipoUsu";

const headCells = [
  {
    id: "1",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "ID USUARIO",
    textAlign: "center",
  },
  {
    id: "2",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "USUARIO",
    textAlign: "center",
  },
  {
    id: "3",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "NOMBRES",
    textAlign: "center",
  },
  {
    id: "opciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: " OPCIONES",
    textAlign: "center",
  },
];

function TablaUuariosWebs() {
  const [mostrar, setMostrar] = useState(false);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [usuario, setUsuario] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [idUsuario, setIdUsuario] = useState();
  const [tributo, setTributo] = useState([]);
  const [anioActu, setAnioActu] = useState(localStorage.getItem("anioactu"));
  const [juridico, setJuridico] = useState(0);
  const [natural, setNatural] = useState(0);
  const [judi, setJudi] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [records, setRecords] = useState([]);
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const accuserweb = JSON.parse(localStorage.getItem("accuserweb"));

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idusuarioweb.includes(target.value) ||
              x.login.toLowerCase().includes(target.value.toLowerCase()) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  useEffect(() => {
    seleccionarUsuarios();
  }, []);

  const seleccionarUsuarios = () => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/usuarioweb/getallusuariosweb`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
            setActivate(false);
          } else {
            setRecords([]);
          }
        }

        setActivate(false);
      })
      .catch((error) => {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const SelectUsuario = (idusuario) => {
    setActivate(true);
    let campos = "*";
    let nomtab = "usuarioweb";
    let nomid = "idusuarioweb";

    let endpoint = `${op.conexion}/api/consultaweb/modeli?campos=${campos}&id=${idusuario}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.idusuarioweb > 0) {
            setUsuario(response.data);
            setIdUsuario(response.data.idusuarioweb);
            setJuridico(response.data.juridico);
            seleccionarTriburos(response.data.idusuarioweb);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarTriburos = (id) => {
    let endpoint = `${op.conexion}/api/usuarioweb/consultatributos?id=${id}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setTributo(response.data);
            setMostrar(true);
          } else {
            setMostrar(true);
            setTributo([]);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const gestionarUsuarios = (op, id) => (e) => {
    setOperacion(op);

    if (op === 4) {
      if (accuserweb.substring(0, 1) !== "0") {
        SelectUsuario(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 1) {
      if (accuserweb.substring(1, 2) !== "0") {
        setMostrar1(true);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 2) {
      if (accuserweb.substring(2, 3) !== "0") {
        SelectUsuario(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 3) {
      if (accuserweb.substring(3, 4) !== "0") {
        SelectUsuario(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    }
  };

  const cerrarToast = () => {
    setToast({
      mostrar: false,
    });
  };

  const cerrarModalActualizar = () => {
    setMostrar(false);
    seleccionarUsuarios();
  };

  const cerrarModal = () => {
    setMostrar1(false);
  };

  const validarActuUsuario = () => {
    setMostrar(false);
    seleccionarUsuarios();
  };

  return (
    <div className="h-100 w-100 p-0 m-0">
      <div className="container">
        <div className="content">
          <div className="card px-3 py-2">
            <div className="col-md-12 row m-0 py-1">
              <div className="col-md-2">
                <input
                  type="text"
                  className="form-control form-control-sm rounded-pill"
                  onChange={handleSearch}
                  placeholder="Buscar"
                />
              </div>
              <div className="col-md-1 ml-auto">
                <button
                  onClick={gestionarUsuarios(1, "")}
                  style={{ marginBottom: "5px" }}
                  className={
                    accuserweb.substring(1, 2) === "0"
                      ? "btn btn-sm btn-secondary rounded-circle"
                      : "btn btn-sm btn-primary rounded-pill"
                  }
                >
                  <i className="fas fa-plus"> incluir</i>{" "}
                </button>
              </div>
            </div>
            <div className="col-md-12" style={{ margin: "auto" }}>
              <TblContainer>
                <TblHead />

                <TableBody>
                  {records &&
                    recordsAfterPagingAndSorting().map((item, index) => (
                      <TableRow key={index} style={{ padding: "0" }}>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "center", width: "50px" }}
                        >
                          {item.idusuarioweb}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "start", width: "250px" }}
                        >
                          {item.login}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "start", width: "250px" }}
                        >
                          {item.nombre}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "center", width: "100px" }}
                        >
                          <button
                            onClick={gestionarUsuarios(2, item.idusuarioweb)}
                            className={
                              accuserweb.substring(2, 3) === "0"
                                ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                : "btn btn-sm  btn-primary rounded-pill ml-2"
                            }
                          >
                            <i className="fa fa-key"> Gestionar Usuario</i>
                          </button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </TblContainer>
              <TblPagination />
            </div>
          </div>
        </div>
      </div>
      <ToastsGeneral
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
      <ModalConfigUserWeb
        show={mostrar}
        onHideCancela={cerrarModalActualizar}
        onHideAcepta={validarActuUsuario}
        onHideRender={SelectUsuario}
        tributo={tributo}
        usuario={usuario}
        idusuario={idUsuario}
        operacion={operacion}
        juridico={juridico}
      />
      <SelectTipoUsu
        show={mostrar1}
        onHideCancela={cerrarModal}
        onHideRender={validarActuUsuario}
      />
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
    </div>
  );
}

export default TablaUuariosWebs;



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/tablaUsuariosWebs.js